import { TemplateType } from "@nocios/presentation-kit";

import DATA_MAIN_1 from "./1DATA_MAIN";
import DATA_MAIN_2 from "./2DATA_MAIN";
import DATA_MAIN_3 from "./3DATA_MAIN";
import DATA_MAIN_4 from "./4DATA_MAIN";
import DATA_MAIN_5 from "./5DATA_MAIN";
import DATA_MAIN_6 from "./6DATA_MAIN";
import DATA_MAIN_7 from "./7DATA_MAIN";
import DATA_MAIN_8 from "./8DATA_MAIN";
import DATA_MAIN_9 from "./9DATA_MAIN";

const DEMO_WORKFLOW = [
  { page: 1, type: "main-template" as TemplateType, dataTemplate: DATA_MAIN_1 },
  { page: 2, type: "main-template" as TemplateType, dataTemplate: DATA_MAIN_2 },
  { page: 3, type: "main-template" as TemplateType, dataTemplate: DATA_MAIN_3 },
  { page: 4, type: "main-template" as TemplateType, dataTemplate: DATA_MAIN_4 },
  { page: 5, type: "main-template" as TemplateType, dataTemplate: DATA_MAIN_5 },
  { page: 6, type: "main-template" as TemplateType, dataTemplate: DATA_MAIN_6 },
  { page: 7, type: "main-template" as TemplateType, dataTemplate: DATA_MAIN_7 },
  { page: 8, type: "main-template" as TemplateType, dataTemplate: DATA_MAIN_8 },
  { page: 9, type: "main-template" as TemplateType, dataTemplate: DATA_MAIN_9 },
];

export default DEMO_WORKFLOW;
